export default __webpack_public_path__ + "static/media/janela-perfil.40e58318.svg";